<template>
  <div class="overlay">
    <Spinner />
  </div>
</template>

<script setup>
import Spinner from '@/components/Spinner.vue'
</script>

<style scoped>
.overlay {
  position: fixed;
  inset: 0; /* plein écran */
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(4px);

  display: flex;
  align-items: center;
  justify-content: center;

  z-index: 9999;
}
</style>
